export const HEADER_KEY = 'header';
export const PARAGRAPH_KEY = 'paragraph';
export const LIST_KEY = 'list';
export const DELIMITER_KEY = 'delimiter';
export const IMAGE_KEY = 'image';
export const CODE_KEY = 'code';
export const RAW_TOOL_KEY = 'rawTool';
export const QUOTE_KEY = 'quote';
export const TABLE_KEY = 'table';

export const DATA_KEY = 'data';
export const ERROR_KEY = 'error';
